"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var Blockie_1 = require("../Blockie");

var Hash_1 = require("./Hash");

var Image_1 = __importDefault(require("./Image"));

var Head_1 = __importDefault(require("../Card/Head"));

var get_1 = __importDefault(require("lodash/get"));

var OffsetBlockyImage = Blockie_1.withBlockySrc(Image_1.default);

var renderParties = function renderParties(_a) {
  var parties = _a.boundWitness.parties;
  return react_1.default.createElement(react_1.Fragment, null, (parties || []).map(function (party, i, arr) {
    return react_1.default.createElement(OffsetBlockyImage, {
      key: get_1.default(party, 'publicKey'),
      seed: get_1.default(party, 'publicKey'),
      className: 'rounded border border-dark',
      style: {
        marginBottom: (arr.length - 1) * 10,
        marginRight: (arr.length - 1) * 10
      },
      offset: i * 10
    });
  }));
};

var renderDisplayNames = function renderDisplayNames(_a) {
  var parties = _a.boundWitness.parties;
  return react_1.default.createElement("div", {
    className: 'ml-3',
    style: {
      minWidth: 0
    }
  }, react_1.default.createElement(Hash_1.MinHash, {
    size: 20,
    value: get_1.default(parties, '[0].publicKey')
  }), (parties || []).slice(1).map(function (party, i) {
    return react_1.default.createElement(Hash_1.MinHash, {
      key: i,
      value: react_1.default.createElement("small", null, get_1.default(party, 'publicKey'))
    });
  }));
};

var renderViewOrigin = function renderViewOrigin() {
  return react_1.default.createElement("a", {
    className: 'mb-0 line-height-1 text-success cursor-pointer'
  }, "View Origin \u2192");
};

exports.default = function (_a) {
  var onClick = _a.onClick,
      className = _a.className,
      boundWitness = _a.boundWitness;
  return react_1.default.createElement(Head_1.default, {
    onClick: onClick,
    className: className,
    renderIcon: renderParties,
    renderTitle: renderDisplayNames,
    renderAction: renderViewOrigin,
    boundWitness: boundWitness
  });
};